import { ADICIONAR_FILTRO_MAPA_VEICULO } from '../types'

export default function adicionarFiltroMapaVeiculo (filtro) {
  return {
    type: ADICIONAR_FILTRO_MAPA_VEICULO,
    payload: filtro
  }
}
